var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showButton),expression:"showButton"}],staticClass:"btn-calendar",attrs:{"href":"/calendar"}},[_c('span',[_vm._v(_vm._s(_vm.__('Ver no calendário')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }